import React, { useMemo } from 'react';
import Loading from '../../components/globales/Loading';
import TablaLayout from '../../components/globales/TablaLayout';
import ModalDynamic from '../../components/globales/ModalDynamic';
import useCrud from '../../hooks/useCrud';
import ENDPOINTS from '../../api/endpoints';
import { tipoPreguntaSchema } from '../../services/validators';

export default function TiposPregunta() {
    const keyField = 'id';

    const initForm = () => ({
        nombre: '',
        componente: '',
        descripcion: ''
    });

    const tiposPreguntaEndpoints = useMemo(() => ({
        listar: ENDPOINTS.encuestasTiposPreguntas.listar,
        crear: ENDPOINTS.encuestasTiposPreguntas.crear,
        actualizar: ENDPOINTS.encuestasTiposPreguntas.actualizar,
        borrar: ENDPOINTS.encuestasTiposPreguntas.borrar
    }), []);

    const columns = [
        { label: 'No', key: 'index', align: 'center', render: (_, idx) => idx + 1 },
        { label: 'Nombre', key: 'nombre', width: '30%' },
        { label: 'Componente', key: 'componente', width: '30%' },
        { label: 'Descripción', key: 'descripcion', as: 'textarea', width: '40%' }
    ];

    const {
        data,
        loading,
        error,
        showModal,
        actionType,
        formData,
        errors,
        openModal,
        closeModal,
        handleChange,
        submit,
        remove
    } = useCrud(tiposPreguntaEndpoints, { keyField, initForm, columns, schema: tipoPreguntaSchema });

    if (loading) return <Loading mensaje="Cargando Tipos de Pregunta..." />;
    if (error) return <div className="text-danger">Error: {error.message}</div>;

    return (
        <div className="container">
            <TablaLayout
                title="Tipos de Pregunta"
                data={data}
                columns={columns}
                keyField={keyField}
                onCreate={() => openModal('crear')}
                onView={item => openModal('consultar', item)}
                onEdit={item => openModal('editar', item)}
                onDelete={remove}
                disableDelete={item => item.registros_preguntas > 0}
            />

            <ModalDynamic
                show={showModal}
                accion={actionType}
                title="Tipo de Pregunta"
                columns={columns}
                formData={formData}
                errors={errors}
                onChange={handleChange}
                onSubmit={submit}
                onClose={closeModal}
            />
        </div>
    );
}
